import { render, staticRenderFns } from "./Ampliacion.vue?vue&type=template&id=596c10fb"
import script from "./Ampliacion.vue?vue&type=script&lang=js"
export * from "./Ampliacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports